import { jsx as r } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ r(
  "path",
  {
    d: "M10 5L3 11.9999M3 11.9999L10 18.9999M3 11.9999H21",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }
);
export {
  t as default
};
